<template>
  <div class="app-bar">
    <div class="app-bar__logo">
      <router-link to="/">
        <b-img
          src="./static/base/primary_Logo_2x_thumb.png"
          alt="Anchor Loans Logo"
          title="Anchors Loans Logo"
          class="app-bar__logo__img" />
      </router-link>
    </div>
    <div class="app-bar--actions">
      <slot name="actions">
        <a
          @click="checkEnv"
          href="#"
          class="app-bar__actions__btn">
          &lt; Back to Website
      </a>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnchorNavbarPublic',
  methods: {
    redirectToLink() {
      location.href = 'https://www.anchorloans.com/';
    },
    checkEnv() {
      if (process.env.NODE_ENV !== 'production') {
        this.$swal({
          title: 'Attention!',
          text: `You're about to leave '${process.env.NODE_ENV}' environment.`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'I\'m fine',
        }).then((result) => {
          if (result.value) {
            this.redirectToLink();
          }
        });
      } else {
        this.redirectToLink();
      }
    },
  },
};
</script>
<style scoped>
.app-bar {
  --primary-color: #071b31;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: var(--primary-color);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.app-bar__logo {
  display: flex;
  flex-grow: 1;
}

.app-bar__logo__img {
  width: 100%;
  max-width: 150px;
  max-height: 1rem;
}

.app-bar__actions {
  display: flex;
  align-items: flex-end;
}

.app-bar__actions__btn,.app-bar__actions__menu {
  display: block;
  color: #051f3a;
  background-color: #36ffd9;
  font-weight: 400;
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  padding: 6px 12px;
}

a:hover {
  background-color: #00434e;
  color: #36ffd9;
  text-decoration: none;
}

.app-bar__actions__menu{
  border: 0;
  position: relative;
}
.app-bar__actions__menu ul{
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: var(--primary-color);
  color: #ffffff;
  border: 1px solid #36FFD9;
  border-radius: 4px;
  font-size: 14px;
  line-height: 22px;
  padding: 6px 12px;
  z-index: 100;
}
.app-bar__actions__menu:hover ul{
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/base/navbar/AnchorNavbarPublic.vue